//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'examineDialog',
  data: function data() {
    return {
      labelWidth: 60,
      dialogVisible: false,
      loading: false,
      config: [],
      id: 0
    };
  },
  computed: {},
  methods: {
    handleClose: function handleClose() {
      this.dialogVisible = false;
    },
    handleOpen: function handleOpen(config, id) {
      this.config = config;
      this.id = id;
      this.dialogVisible = true;
    },
    handleConfirm: function handleConfirm() {
      this.handleClose();
      this.$emit('isOk', this.config, this.id);
    }
  }
};